import { css } from 'linaria';
import { strictBreakpoints } from 'media';

export const questionStyles = css`
	margin-bottom: 8px;
	&:last-of-type {
		margin-bottom: 0px;
	}
	${strictBreakpoints.onlyMobile} {
		margin-bottom: 16px;
	}
	.question {
		&__top {
			display: flex;
		}
		&__triangle {
			width: 0;
			height: 0;
			margin-top: 8px;
			border-top: 5px solid transparent;
			border-bottom: 5px solid transparent;
			border-left: 10px solid #ced0d6;
			${strictBreakpoints.onlyMobile} {
				margin-top: 4px;
			}
			&__open {
				transform: rotate(90deg);
			}
		}
		&__text {
			margin-left: 7px;
			cursor: pointer;
		}
		&__answer {
			display: none;
			margin-left: 15px;
			&__open {
				display: block;
			}
		}
	}
`;
